import React from "react";
import crossPill from "svg/crossPill.svg";
import checkmark from "svg/checkmark.svg";
import "./style.scss";
export const searchContainerColumns = [
  {
    id: 1,
    name: "District",
    dataKey: "district",
    sortable: true,
  },
  {
    id: 2,
    name: "Store No",
    dataKey: "storeNbr",
    sortable: true,
  },
  {
    id: 3,
    name: "Labor Code",
    dataKey: "laborCode",
    class: "laborWidth",
    sortable: true,
  },
  {
    id: 4,
    name: "Installer Pay Rate",
    dataKey: "installerPayRate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 5,
    name: "Bill Rates($)",
    dataKey: "laborBillRate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 6,
    name: "Percent Return",
    dataKey: "percentReturn",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 7,
    name: "Account Number",
    dataKey: "accountNumber",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 8,
    name: "Account Name",
    dataKey: "accountName",
    sortable: true,
  },
  {
    id: 9,
    name: "Job",
    dataKey: "jobNumber",
    sortable: true,
  },
  {
    id: 10,
    name: "Status",
    dataKey: "approvalStatus",
    sortable: true,
  },
  {
    id: 11,
    name: "Verification Date",
    dataKey: "verificationDate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
];

export const verifyDataColumns = [
  {
    id: 1,
    name: "District",
    dataKey: "district",
    sortable: true,
  },
  {
    id: 2,
    name: "Store No",
    dataKey: "storeNbr",
    sortable: true,
  },
  {
    id: 3,
    name: "Labor Code",
    dataKey: "laborCode",
    class: "laborWidth",
    sortable: true,
  },
  {
    id: 4,
    name: "Installer Pay Rate",
    dataKey: "installerPayRate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 5,
    name: "Bill Rates($)",
    dataKey: "laborBillRate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 6,
    name: "Percent Return",
    dataKey: "percentReturn",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 7,
    name: "Account Number",
    dataKey: "accountNumber",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 8,
    name: "Account Name",
    dataKey: "accountName",
    sortable: true,
  },
  {
    id: 9,
    name: "Job",
    dataKey: "jobNumber",
    sortable: true,
  },
  {
    id: 10,
    name: "Status",
    dataKey: "approvalStatus",
    sortable: true,
  },
  {
    id: 11,
    name: "Verification Date",
    dataKey: "verificationDate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
];

export const fcNaColumns = [
  {
    id: 1,
    name: "Store No",
    dataKey: "storeNbr",
    sortable: true,
  },
  {
    id: 2,
    name: "Store Name",
    dataKey: "nam",
    sortable: true,
  },
  {
    id: 3,
    name: "Labor Code",
    dataKey: "laborCode",
    class: "laborWidth",
    sortable: true,
  },
  {
    id: 4,
    name: "Bill Rates($)",
    dataKey: "laborBillRate",
    sortable: true,
  },
  {
    id: 5,
    name: "Account Number",
    dataKey: "accountNumber",
    sortable: true,
  },
  {
    id: 6,
    name: "Account Name",
    dataKey: "accountName",
    sortable: true,
  },
  {
    id: 7,
    name: "Job",
    dataKey: "jobNumber",
    sortable: true,
  },
];

export const pendingPricesTabColumns = [
  {
    id: 1,
    name: "Checkbox",
    sortable: false,
  },
  {
    id: 2,
    name: "District",
    dataKey: "district",
    sortable: true,
  },
  {
    id: 3,
    name: "Store No",
    dataKey: "storeNbr",
    sortable: true,
  },
  {
    id: 4,
    name: "Labor Code",
    dataKey: "laborCode",
    class: "laborWidth",
    sortable: true,
  },
  {
    id: 5,
    name: "Installer Pay Rate",
    dataKey: "installerPayRate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 6,
    name: "Bill Rates($)",
    dataKey: "laborBillRate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 7,
    name: "Percent Return",
    dataKey: "percentReturn",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 8,
    name: "New Installer Pay Rate",
    dataKey: "installerPayRateNew",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 9,
    name: "New Bill Rates($)",
    dataKey: "laborBillRateNew",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 10,
    name: "New Percent Return",
    dataKey: "percentReturnNew",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
  {
    id: 11,
    name: "Status",
    dataKey: "approvalStatus",
    sortable: true,
  },
  {
    id: 12,
    name: "Verification Date",
    dataKey: "verificationDate",
    adj_class: "table-root__body__tr__td__nextLine_text",
    gap_cls: "gap-2",
    sortable: true,
  },
];

export const expandedItemsSearch = [
  {
    keyName: "District",
    valueName: "district",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Store No",
    valueName: "storeNbr",
    nm: "nam",
    addr: "addr",
    city: "city",
    st: "str",
    zip: "zip",
    phone: "phone",
    contact: "contact",
    verificationTime: "verificationTime",
    classNameOne: "m-b-16",
    classNameTwo: "customer-txt",
  },
  {
    keyName: "Labor Code",
    valueName: "laborCode",
    valueName1: "laborCode",
    valueName2: "laborCodeDesc",
    valueName3: "laborCodeDescExt",
    classNameOne: "m-b-16",
    classNameTwo: "customer-txt",
  },
  {
    keyName: "Installer Pay Rate",
    valueName: "installerPayRate",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Bill Rates($)",
    valueName: "laborBillRate",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Percent Return",
    valueName: "percentReturn",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Account Number",
    valueName: "accountNumber",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Account Name",
    valueName: "accountName",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Job Number",
    valueName: "jobNumber",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Job Name",
    valueName: "jobName",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Approval Status",
    valueName: "approvalStatus",
    installerPayRate: "installerPayRate",
    laborBillRate: "laborBillRate",
    installerRateNew: "installerPayRateNew",
    laborRateNew: "laborBillRateNew",
    classNameOne: "m-b-16",
    classNameTwo: "customer-txt",
  },
  {
    keyName: "Verification Date",
    valueName: "verificationDate",
    classNameOne: "m-b-16",
  },
];

export const pendingItemsSearch = [
  {
    keyName: "District",
    valueName: "district",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Store No",
    valueName: "storeNbr",
    nm: "nm",
    addr: "addr",
    city: "city",
    st: "str",
    zip: "zip",
    phone: "phone",
    verificationTime: "verificationTime",
    contact: "contact",
    classNameOne: "m-b-16",
    classNameTwo: "customer-txt",
  },
  {
    keyName: "Labor Code",
    valueName: "laborCode",
    valueName1: "laborCode",
    valueName2: "laborCodeDesc",
    valueName3: "laborCodeDescExt",
    classNameOne: "m-b-16",
    classNameTwo: "customer-txt",
  },
  {
    keyName: "Installer Pay Rate",
    valueName: "installerPayRate",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Bill Rates($)",
    valueName: "laborBillRate",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Percent Return",
    valueName: "percentReturn",
    classNameOne: "m-b-16",
  },
  {
    keyName: "New Installer Pay Rate",
    valueName: "installerPayRateNew",
    classNameOne: "m-b-16",
  },
  {
    keyName: "New Bill Rates($)",
    valueName: "laborBillRateNew",
    classNameOne: "m-b-16",
  },
  {
    keyName: "New Percent Return",
    valueName: "percentReturnNew",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Account Number",
    valueName: "accountNumber",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Account Name",
    valueName: "accountName",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Job Number",
    valueName: "jobNumber",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Job Name",
    valueName: "jobName",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Approval Status",
    valueName: "approvalStatus",
    installerPayRate: "installerPayRate",
    laborBillRate: "laborBillRate",
    installerRateNew: "installerPayRateNew",
    laborRateNew: "laborBillRateNew",
    classNameOne: "m-b-16",
    classNameTwo: "customer-txt",
  },
  {
    keyName: "Verification Date",
    valueName: "verificationDate",
    classNameOne: "m-b-16",
  },
];

export const expPriceHeaders = [
  {
    id: 1,
    name: "Labor Code",
    name2: "laborCodeDesc",
    dataKey: "laborCode",
    class: "laborCode",
    classNameOne: "m-b-16",
  },
  {
    id: 2,
    name: "Exception Bill Rate",
    dataKey: "exceptionPrice",
    class: "exceptionPrice",
    classNameOne: "m-b-16",
  },
  {
    id: 3,
    name: "Exception Installer Pay Rate",
    dataKey: "installerRate",
    class: "installerRate",
    classNameOne: "m-b-16",
  },
  {
    id: 4,
    name: "Standard Bill Rate",
    dataKey: "standardBillRate",
    class: "standardBillRate",
    classNameOne: "m-b-16",
  },
  {
    id: 5,
    name: "Standard Installer Pay Rate",
    dataKey: "standardInstallerRate",
    class: "standardInstallerRate",
    classNameOne: "m-b-16",
  },
  {
    id: 6,
    name: "Edit",
    class: "edit",
    classNameOne: "m-b-16",
  },
  {
    id: 7,
    name: "Delete",
    class: "delete",
  },
];

export const currencyValue = (value) => {
  value = value?.toString().replace("$", "");
  if (!value || isNaN(value) || value === null) return "";
  // eslint-disable-next-line
  value = value.toString().replace(/\,/g, "");
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
};

export const filterColumns = [
  "district",
  "storeNbr",
  "laborCode",
  "laborCodeDesc",
  "installerPayRate",
  "laborBillRate",
  "accountNumber",
  "accountName",
  "approvalStatus",
  "verificationDate",
];

export const xlsxSettings = {
  fileName: "FC_Labor_table_" + new Date().toLocaleString(),
  extraLength: 3,
  writeMode: "writeFile",
  writeOptions: {},
  RTL: false,
};

export const xlsxcolumns = [
  { label: "District", value: "district" },
  { label: "Store", value: (row) => row.storeNbr + " - " + row.nam },
  { label: "Labor Code", value: (row) => row.laborCode + " - " + row.laborCodeDesc },
  { label: "Installer Pay Rate", value: "installerPayRate" },
  { label: "Bill Rates($)", value: "laborBillRate" },
  { label: "Percent Return", value: "percentReturn" },
  { label: "Account Number", value: "accountNumber" },
  { label: "Account Name", value: "accountName" },
  { label: "Job", value: (row) => (!row.jobName ? row.jobNumber : row.jobNumber + " : " + row.jobName) },
  { label: "Status", value: "approvalStatus" },
  { label: "Verification Date", value: "verificationDate" },
];

export const fcNaXLSXcolumns = [
  { label: "Store No", value: "storeNbr" },
  { label: "Store Name", value: "nam" },
  { label: "Labor Code", value: (row) => row.laborCode + "- " + row.laborCodeDesc },
  { label: "Bill Rates($)", value: "laborBillRate" },
  { label: "Account Number", value: "accountNumber" },
  { label: "Account Name", value: "accountName" },
  { label: "Job", value: (row) => (!row.jobName ? row.jobNumber : row.jobNumber + " : " + row.jobName) },
];

export const pendingXlsxcolumns = [
  { label: "District", value: "district" },
  { label: "Store", value: (row) => row.storeNbr + " - " + row.nam },
  { label: "Labor Code", value: (row) => row.laborCode + "- " + row.laborCodeDesc },
  { label: "Installer Pay Rate", value: "installerPayRate" },
  { label: "Bill Rates($)", value: "laborBillRate" },
  { label: "Percent Return", value: "percentReturn" },
  { label: "New Installer Pay Rate", value: "installerPayRateNew" },
  { label: "New Bill Rates($)", value: "laborBillRateNew" },
  { label: "New Percent Return", value: "percentReturnNew" },
  { label: "Account Number", value: "accountNumber" },
  { label: "Account Name", value: "accountName" },
  { label: "Job", value: (row) => (!row.jobName ? row.jobNumber : row.jobNumber + " : " + row.jobName) },
  { label: "Status", value: "approvalStatus" },
  { label: "Verification Date", value: "verificationDate" },
];

export const formatPercentReturn = (laborBillRate, installerPayRate) => {
  return isNaN(getPercentReturn(laborBillRate, installerPayRate))
    ? "N/A"
    : getPercentReturn(laborBillRate, installerPayRate) + "%";
};
export const getPercentReturn = (totalProfit, loss) => {
  return (((totalProfit - loss) / totalProfit) * 100).toFixed(1);
};

export const verifiedState = (item) => {
  const vTimeGreaterThan90Days =
    (item != "null" && item != "" ? new Date(item) < new Date(new Date().setDate(new Date().getDate() - 90)) : true) &&
    !!item;
  return <img src={vTimeGreaterThan90Days ? crossPill : checkmark} />;
};
